module.exports = __webpack_public_path__ + "files/acd3720a677ec19c2e6a0775a37788c0.png";